import script from "./CheckPointCompetenceForm.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckPointCompetenceForm.vue?vue&type=script&setup=true&lang=js"

import "./CheckPointCompetenceForm.vue?vue&type=style&index=0&id=33b3e9d4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33b3e9d4"]])

export default __exports__